// Field definitions shared by patient registration and patient editing.
export const PATIENT_SECTIONS = [
  {
    id: "demographics", label: "Demographics", cols: 3,
    fields: [
      ["name", "Full name *"], ["age", "Age", "number"], ["dob", "Date of birth", "date"],
      ["gender", "Gender"], ["blood_group", "Blood group"], ["marital_status", "Marital status"],
      ["religion", "Religion"], ["occupation", "Occupation"], ["aadhar", "Aadhar number"],
      ["passport", "Passport number"], ["height", "Height (cm)", "number"], ["weight", "Weight (kg)", "number"],
      ["insurance", "Insurance"], ["policy_number", "Policy number"],
    ],
  },
  {
    id: "contact", label: "Contact", cols: 2,
    fields: [
      ["phone", "Phone"], ["whatsapp", "WhatsApp number"], ["email", "Email"],
      ["emergency_contact", "Emergency contact"], ["guardian", "Guardian"], ["address", "Address", "area"],
    ],
  },
  {
    id: "clinical", label: "Clinical history", cols: 2,
    fields: [
      ["allergies", "Allergies", "area"], ["past_history", "Past medical history", "area"],
      ["surgical_history", "Surgical history", "area"], ["family_history", "Family history", "area"],
      ["drug_history", "Drug history", "area"], ["social_history", "Social history", "area"],
      ["vaccination", "Vaccination", "area"],
    ],
  },
  {
    id: "lifestyle", label: "Personal history", cols: 3,
    fields: [
      ["smoking", "Smoking"], ["alcohol", "Alcohol"], ["tobacco", "Tobacco"],
      ["diet", "Diet"], ["exercise", "Exercise"], ["sleep", "Sleep"],
    ],
  },
];

export const PATIENT_EMPTY = Object.fromEntries(
  PATIENT_SECTIONS.flatMap((s) => s.fields.map(([k]) => [k, ""]))
);

export const NUMERIC_PATIENT_FIELDS = ["age", "height", "weight"];

export function patientPayload(form, facilityId) {
  const out = { ...form, facility_id: facilityId };
  NUMERIC_PATIENT_FIELDS.forEach((k) => { out[k] = Number(form[k]) || 0; });
  return out;
}
